import React, { useEffect, useState } from 'react';
import { Header } from '../../components/Header';
import { Loading } from '../../components/Loading';
import { getCrmStats } from '../../libs/db-lib';
import { TextOnly } from '../../components/Text';
import CopyLink from '../../components/CopyLink';
import LoaderButton from '../../components/LoaderButton';
import Accordion from '../../components/Accordion';

const CRMStats = () => {
  const [isLoadingStats, setIsLoadingStats] = useState(false);
  const [crmStats, setCrmStats] = useState<any | undefined>();
  const [displayDeclineStats, setDisplayDeclineStats] = useState<any>();
  const [displayTopRecentStats, setDisplayTopRecentStats] = useState<any>();
  const [displayTopGrowthStats, setDisplayTopGrowthStats] = useState<any>();
  const [displayCancelledShops, setDisplayCancelledShops] = useState<any>();
  const [displayNewShops, setDisplayNewShops] = useState<any>();
  
  const [numCancelled, setNumCancelled] = useState(0);
  const [numSignedUp, setNumSignedUp] = useState<number>(0);
  const [numCrmShops, setNumCrmShops] = useState<number>(0);

  const roundDecimal = (value, decimals=2) => {
    const toNumber = parseFloat(value);
    return toNumber.toFixed(decimals);
  }

  const roundInt = (value) => {
    const toNumber = parseInt(value);
    return toNumber;
  }


  useEffect(() => {
    loadStats();
  }, []);

  useEffect(() => {
    if (!crmStats) return;

    const topDeclined = crmStats.topDeclined;
    setDisplayDeclineStats(topDeclined.map((stat, i) => {
      const ret = (
        <tr key={`row-${i}`}>
          <td className='table-data-left'>
            <CopyLink
              content={stat.shopName}
              redirect={'/shopFunctions/getShopSummary'}
              type={'SHOP ID'}
              action={'search'}
              urlParams={`?query=${stat.shopID}&queryType=SHOP+ID`}
              showCopy={false}
            />
          </td>
          <td className='table-data-right'>{roundDecimal(stat.last30Avg)}</td>
          <td className='table-data-right'>{roundDecimal(stat.last10Avg)}</td>
          <td className='table-data-right'>{roundInt(stat.growthScore)}%</td>
          <td className='table-data-left'>{stat.crmSubscriptionState}</td>
        </tr>
      );

      return ret;
    }));

    const topLast30Days = crmStats.topLast30Days;
    setDisplayTopRecentStats(topLast30Days.map((stat, i) => {
      const ret = (
        <tr key={`row-${i}`}>
          <td className='table-data-left'>
            <CopyLink
              content={stat.shopName}
              redirect={'/shopFunctions/getShopSummary'}
              type={'SHOP ID'}
              action={'search'}
              urlParams={`?query=${stat.shopID}&queryType=SHOP+ID`}
              showCopy={false}
            />
          </td>
          <td className='table-data-right'>{roundDecimal(stat.last30Avg)}</td>
          <td className='table-data-right'>{roundDecimal(stat.last10Avg)}</td>
          <td className='table-data-right'>{roundInt(stat.growthScore)}%</td>
          <td className='table-data-left'>{stat.crmSubscriptionState}</td>
        </tr>
      );

      return ret;
    }));

    const topGrowth = crmStats.topGrowth;
    setDisplayTopGrowthStats(topGrowth.map((stat, i) => {
      const ret = (
        <tr key={`row-${i}`}>
          <td className='table-data-left'>
            <CopyLink
              content={stat.shopName}
              redirect={'/shopFunctions/getShopSummary'}
              type={'SHOP ID'}
              action={'search'}
              urlParams={`?query=${stat.shopID}&queryType=SHOP+ID`}
              showCopy={false}
            />
          </td>
          <td className='table-data-right'>{roundDecimal(stat.last30Avg)}</td>
          <td className='table-data-right'>{roundDecimal(stat.last10Avg)}</td>
          <td className='table-data-right'>{roundInt(stat.growthScore)}%</td>
          <td className='table-data-left'>{stat.crmSubscriptionState}</td>
        </tr>
      );

      return ret;
    }));

    const cancelledShops = crmStats.cancelledShops;
    cancelledShops.sort((a, b) => a.shopName - b.shopName);
    setNumCancelled(cancelledShops.length);
    setDisplayCancelledShops(cancelledShops.map((stat, i) => {
      const ret = (
        <tr key={`row-${i}`}>
          <td className='table-data-left'>
            <CopyLink
              content={stat.shopName}
              redirect={'/shopFunctions/getShopSummary'}
              type={'SHOP ID'}
              action={'search'}
              urlParams={`?query=${stat.shopID}&queryType=SHOP+ID`}
              showCopy={false}
            />
          </td>
          <td className='table-data-left'>
            {stat.crmSubscriptionState}
          </td>
        </tr>
      );

      return ret;
    }));

    const newShops = crmStats.newShops;
    newShops.sort((a, b) => a.shopName - b.shopName);
    setNumSignedUp(newShops.length);
    setDisplayNewShops(newShops.map((stat, i) => {
      const ret = (
        <tr key={`row-${i}`}>
          <td className='table-data-left'>
            <CopyLink
              content={stat.shopName}
              redirect={'/shopFunctions/getShopSummary'}
              type={'SHOP ID'}
              action={'search'}
              urlParams={`?query=${stat.shopID}&queryType=SHOP+ID`}
              showCopy={false}
            />
          </td>
          <td className='table-data-left'>
            {stat.crmSubscriptionState}
          </td>
        </tr>
      );

      return ret;
    }));

    setNumCrmShops(crmStats.totalShops);
  }, [crmStats]);

  const loadStats = async () => {
      setIsLoadingStats(true);
      const stats = await getCrmStats();
      setCrmStats(stats);
      setIsLoadingStats(false);
    }

  return (
    <>
      <Header title={TextOnly('crmStatsLast30')} />
      <div className="l-containe u-margin-bottom-large">
        <LoaderButton
          onClick={() => {
            loadStats()
          }}
          className="c-btn"
          isLoading={isLoadingStats}
          text={TextOnly('refresh')}
          loadingText={TextOnly('loading')}
        />

        {isLoadingStats ? <Loading/>:
        <>
        <p><b>Total CRM Shops: {numCrmShops}</b></p>



        <div className="l-flex-row-wrap u-margin-top-small u-margin-bottom-small">
          
          {/* Declining Shops */}
          <div className="c-stats-widget u-padding-top-large">
            <div className="h2 c-stats-widget__title">
              Activity Declining Shops
            </div>
            <div className="c-stats-widget__label">
              {TextOnly('last30Days')}
            </div>
            <table className='u-text-left'>
              <tbody>
                <tr className='table-header-row'>
                  <th className='table-header-left'>Shop Name</th>
                  <th className='table-header-right'>30 Day Avg</th>
                  <th className='table-header-right'>10 Day Avg</th>
                  <th className='table-header-right'>Growth Score</th>
                  <th className='table-header-left'>CRM Subscription State</th>
                </tr>
                {displayDeclineStats}
              </tbody>
            </table>

            <div className='u-margin-bottom-large'></div>
          </div>

          {/* Top Last 30 Days */}
          <div className="c-stats-widget u-padding-top-large">
            <div className="h2 c-stats-widget__title">
              Top Activity Shops
            </div>
            <div className="c-stats-widget__label">
              {TextOnly('last30Days')}
            </div>
            <table className='u-text-left'>
              <tbody>
                <tr className='table-header-row'>
                  <th className='table-header-left'>Shop Name</th>
                  <th className='table-header-right'>30 Day Avg</th>
                  <th className='table-header-right'>10 Day Avg</th>
                  <th className='table-header-right'>Growth Score</th>
                  <th className='table-header-left'>CRM Subscription State</th>
                </tr>

                {displayTopRecentStats}
              </tbody>
            </table>

            <div className='u-margin-bottom-large'></div>
          </div>

          {/* Top Growth Stats Last 30 Days */}
          <div className="c-stats-widget u-padding-top-large">
            <div className="h2 c-stats-widget__title">
              Activity Growing Shops
            </div>
            <div className="c-stats-widget__label">
              {TextOnly('last30Days')}
            </div>
            <table className='u-text-left'>
              <tbody>
                <tr className='table-header-row'>
                  <th className='table-header-left'>Shop Name</th>
                  <th className='table-header-right'>30 Day Avg</th>
                  <th className='table-header-right'>10 Day Avg</th>
                  <th className='table-header-right'>Growth Score</th>
                  <th className='table-header-left'>CRM Subscription State</th>
                </tr>

                {displayTopGrowthStats}
              </tbody>
            </table>

            <div className='u-margin-bottom-large'></div>
          </div>
        </div>
        
        <div className='accordion-container'>
          {/* Shops Cancelled In The Last 30 Days */}
          <Accordion
            title={`Cancelled Shops (${numCancelled})`}
            
          >
            <div className="accordion-stats">
              <table className='u-text-left'>
                <tbody>
                  <tr className='table-header-row'>
                    <th className='table-header-left'>Shop Name</th>
                    <th className='table-header-left'>CRM Subscription State</th>
                  </tr>

                  {displayCancelledShops}
                </tbody>
              </table>

              <div className='u-margin-bottom-large'></div>
            </div>
          </Accordion>

          {/* Shops Signed Up for CRM In The Last 30 Days */}
          <Accordion
            title={`New CRM Shops (${numSignedUp})`}
          >
            <div className="accordion-stats">
              <table className='u-text-left'>
                <tbody>
                  <tr className='table-header-row'>
                    <th className='table-header-left'>Shop Name</th>
                    <th className='table-header-left'>CRM Subscription State</th>
                  </tr>

                  {displayNewShops}
                </tbody>
              </table>

              <div className='u-margin-bottom-large'></div>
            </div>
          </Accordion>
        </div>
        </>}
      </div>
    </>
  );
};

export default CRMStats;